var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "relative w-full flex flex-column"
  }, _vm._l(_vm.lines, function (line) {
    return _c('skeleton', {
      key: line,
      staticClass: "w-full",
      class: [line !== _vm.lines ? 'mb-' + _vm.textSpacing : ''],
      attrs: {
        "height": _vm.height,
        "rounded": ""
      }
    });
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }